import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/** Rough shapes of saved things (width / height): posts, reels, pages, notes. */
const SHAPES = [0.8, 1.25, 0.6, 1, 0.75, 1.5, 0.9, 0.56, 1.1, 0.8, 1.3, 0.7];

/**
 * What the Library shows while your mind loads: paper tiles in the grid's
 * own two columns, rising in one after another, each with the soft band of
 * light the cards use while their picture loads (loading-shimmer). Under
 * reduced motion they simply appear, without the sweep.
 */
export function LibrarySkeleton() {
  const reduce = useReducedMotion() ?? false;
  const columns: number[][] = [[], []];
  SHAPES.forEach((ratio, i) => columns[i % 2].push(ratio));
  return (
    <div className="flex gap-3 px-4 pt-1" aria-label="Loading your mind" role="status">
      {columns.map((col, c) => (
        <div key={c} className="flex min-w-0 flex-1 flex-col gap-3">
          {col.map((ratio, r) => {
            const i = r * 2 + c;
            return (
              <motion.div
                key={i}
                className="loading-shimmer rounded-[14px] border border-line !bg-paper-raised"
                style={{ aspectRatio: String(ratio) }}
                initial={reduce ? { opacity: 0 } : { opacity: 0, y: 14, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={reduce ? { duration: 0.2 } : { type: 'spring', stiffness: 500, damping: 38, delay: 0.05 + i * 0.045 }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
